import React from "react";
// import CommonButton from "../../components/commonButton";
// import TableImportImg from "../../assets/images/table/import.png";
// import ExportImportImg from "../../assets/images/table/export.png";
// import AddPropertyImg from "../../assets/images/table/plus.png";
import Input from "../../components/input";
// import { routes } from "../../routes/pageRoutes";
import { FilterIcon } from "../../assets/icons";

const NpaAddImpExprtBtn = ({
  filterValues,
  navigate,
  setFilterValues,
  setFilterModal,
  importBtnHandler,
  setCurrentPage,
  handleExportNpaProperties,
  searchQuery,
  setSearchQuery,
}) => {
  // Check if any value except 'search' is non-empty
// Treat non-empty arrays and non-empty trimmed strings as "active"
const hasValue = (v) =>
  Array.isArray(v) ? v.length > 0
  : typeof v === "string" ? v.trim() !== ""
  : v != null && v !== false; // safety for future booleans/numbers

const isFilterActive = Object.entries(filterValues)
  .filter(([key]) => key !== "search") // exclude search
  .some(([, value]) => hasValue(value));


  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div className="d-flex flex-wrap align-items-center gap-2">
          <Input
            type="search"
            value={searchQuery} // Use the immediate typing state
            placeholder="City, state, property, transaction"
            onChange={(e) => {
              // Update the searchQuery state with every keystroke.
              // The debounce useEffect will handle updating the filterValues.
              setSearchQuery(e.target.value);
            }}
            className="shadow-none base-search"
          />
          <button
            onClick={() => setFilterModal(true)}
            className={`rounded-2 position-relative custom-filter-btn ${
              isFilterActive ? "btn-active" : ""
            }`}
          >
            {/* btn-active --- Apply Filter Class */}
            <div className="d-flex gap-2 align-items-center justify-content-center ">
              <span>
                <FilterIcon height={16} width={16} strokeWidth="1.5" color="" />
              </span>
              <p>Filter</p>
            </div>
          </button>
        </div>
        <div className="action-buttons-container">
          {/* <CommonButton
            icon={<span><img src={TableImportImg} alt="import" /></span>}
            className="btn-primary-light me-2"
            onClick={importBtnHandler}
            title="Import"
            type="button"
          />
          <CommonButton
            icon={<span><img src={ExportImportImg} alt="import" /></span>}
            className="btn-primary-light me-2"
            title="Export"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleExportNpaProperties();
            }}
          /> */}
          {/* <CommonButton
            icon={<span><img src={AddPropertyImg} alt="import" /></span>}
            className="btn-primary"
            title="Add Property"
            onClick={(e) => {
              e.stopPropagation();
              navigate(routes.addNpaPublicProperties);
            }}
          /> */}
        </div>
      </div>
    </>
  );
};

export default NpaAddImpExprtBtn;
